import React from 'react'

interface Props {
  data: {
    placeholders: number
    groups: number
    types: number
    note?: string
  }
}

export const RecognitionResultCard: React.FC<Props> = ({ data }) => (
  <div className="aiClerk-att-recognition">
    <div className="aiClerk-att-recognition__title">识别结果</div>
    <div className="aiClerk-att-recognition__metrics">
      <div className="aiClerk-att-recognition__metric">
        <div className="aiClerk-att-recognition__num">{data.placeholders}</div>
        <div className="aiClerk-att-recognition__label">个照片位</div>
      </div>
      <div className="aiClerk-att-recognition__metric">
        <div className="aiClerk-att-recognition__num">{data.groups}</div>
        <div className="aiClerk-att-recognition__label">个项目组</div>
      </div>
      <div className="aiClerk-att-recognition__metric">
        <div className="aiClerk-att-recognition__num">{data.types}</div>
        <div className="aiClerk-att-recognition__label">种类型</div>
      </div>
    </div>
    {data.note && (
      <div className="aiClerk-att-recognition__note">{data.note}</div>
    )}
  </div>
)
